import { useEffect } from 'react';

const FOCUSABLE =
  'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

/* ──────────────────────────────────────────
   Modal keyboard behavior in one place:
   Escape dismisses, Tab cycles inside the
   dialog instead of escaping to the page.
   Pass dismissable=false while saving.

   The container is read at event time so the
   hook works even when the dialog mounts
   after first render (conditional modals).
   ────────────────────────────────────────── */
export function useModalTrap(containerRef, onClose, dismissable = true) {
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === 'Escape') {
        if (dismissable) onClose();
        return;
      }
      if (e.key !== 'Tab') return;

      const el = containerRef.current;
      if (!el) return;
      const focusables = Array.from(el.querySelectorAll(FOCUSABLE)).filter(
        (n) => n.offsetParent !== null
      );
      if (focusables.length === 0) return;

      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    };

    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [containerRef, onClose, dismissable]);
}
